import React, { FC } from 'react'
import styles from '../Story.module.scss'

type TStoryDividerProps = {}

export const StoryDivider: FC<TStoryDividerProps> = (props) => {
  return (
    <hr className={styles.divider} />
  )
}
